"use strict";

Object.defineProperty(exports, "__esModule", {
  value: !0
});

var _createClass = function () {
  function e(e, a) {
    for (var t = 0; t < a.length; t++) {
      var s = a[t];
      s.enumerable = s.enumerable || !1, s.configurable = !0, "value" in s && (s.writable = !0), Object.defineProperty(e, s.key, s);
    }
  }

  return function (a, t, s) {
    return t && e(a.prototype, t), s && e(a, s), a;
  };
}(),
    _react = require("react"),
    _react2 = _interopRequireDefault(_react),
    _propTypes = require("prop-types"),
    _propTypes2 = _interopRequireDefault(_propTypes),
    _paginator = require("paginator"),
    _paginator2 = _interopRequireDefault(_paginator),
    _Page = require("./Page"),
    _Page2 = _interopRequireDefault(_Page),
    _classnames = require("classnames"),
    _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(e) {
  return e && e.__esModule ? e : {
    default: e
  };
}

function _classCallCheck(e, a) {
  if (!(e instanceof a)) throw new TypeError("Cannot call a class as a function");
}

function _possibleConstructorReturn(e, a) {
  if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return !a || "object" != typeof a && "function" != typeof a ? e : a;
}

function _inherits(e, a) {
  if ("function" != typeof a && null !== a) throw new TypeError("Super expression must either be null or a function, not " + typeof a);
  e.prototype = Object.create(a && a.prototype, {
    constructor: {
      value: e,
      enumerable: !1,
      writable: !0,
      configurable: !0
    }
  }), a && (Object.setPrototypeOf ? Object.setPrototypeOf(e, a) : e.__proto__ = a);
}

var Pagination = function (e) {
  function a() {
    return _classCallCheck(this, a), _possibleConstructorReturn(this, (a.__proto__ || Object.getPrototypeOf(a)).apply(this, arguments));
  }

  return _inherits(a, _react2.default.Component), _createClass(a, [{
    key: "isFirstPageVisible",
    value: function (e) {
      var a = this.props,
          t = a.hideDisabled;
      a.hideNavigation;
      return !(a.hideFirstLastPages || t && !e);
    }
  }, {
    key: "isPrevPageVisible",
    value: function (e) {
      var a = this.props,
          t = a.hideDisabled;
      return !(a.hideNavigation || t && !e);
    }
  }, {
    key: "isNextPageVisible",
    value: function (e) {
      var a = this.props,
          t = a.hideDisabled;
      return !(a.hideNavigation || t && !e);
    }
  }, {
    key: "isLastPageVisible",
    value: function (e) {
      var a = this.props,
          t = a.hideDisabled;
      a.hideNavigation;
      return !(a.hideFirstLastPages || t && !e);
    }
  }, {
    key: "buildPages",
    value: function () {
      for (var e = [], a = this.props, t = a.itemsCountPerPage, s = a.pageRangeDisplayed, i = a.activePage, r = a.prevPageText, l = a.nextPageText, n = a.firstPageText, u = a.lastPageText, o = a.totalItemsCount, p = a.onChange, c = a.activeClass, g = a.itemClass, _ = a.itemClassFirst, f = a.itemClassPrev, d = a.itemClassNext, h = a.itemClassLast, C = a.activeLinkClass, P = a.disabledClass, b = (a.hideDisabled, a.hideNavigation, a.linkClass), v = a.linkClassFirst, m = a.linkClassPrev, k = a.linkClassNext, y = a.linkClassLast, x = (a.hideFirstLastPages, a.getPageUrl), T = new _paginator2.default(t, s).build(o, i), D = T.first_page; D <= T.last_page; D++) e.push(_react2.default.createElement(_Page2.default, {
        isActive: D === i,
        key: D,
        href: x(D),
        pageNumber: D,
        pageText: D + "",
        onClick: p,
        itemClass: g,
        linkClass: b,
        activeClass: c,
        activeLinkClass: C
      }));

      return this.isPrevPageVisible(T.has_previous_page) && e.unshift(_react2.default.createElement(_Page2.default, {
        key: "prev" + T.previous_page,
        pageNumber: T.previous_page,
        onClick: p,
        pageText: r,
        isDisabled: !T.has_previous_page,
        itemClass: (0, _classnames2.default)(g, f),
        linkClass: (0, _classnames2.default)(b, m),
        disabledClass: P
      })), this.isFirstPageVisible(T.has_previous_page) && e.unshift(_react2.default.createElement(_Page2.default, {
        key: "first",
        pageNumber: 1,
        onClick: p,
        pageText: n,
        isDisabled: !T.has_previous_page,
        itemClass: (0, _classnames2.default)(g, _),
        linkClass: (0, _classnames2.default)(b, v),
        disabledClass: P
      })), this.isNextPageVisible(T.has_next_page) && e.push(_react2.default.createElement(_Page2.default, {
        key: "next" + T.next_page,
        pageNumber: T.next_page,
        onClick: p,
        pageText: l,
        isDisabled: !T.has_next_page,
        itemClass: (0, _classnames2.default)(g, d),
        linkClass: (0, _classnames2.default)(b, k),
        disabledClass: P
      })), this.isLastPageVisible(T.has_next_page) && e.push(_react2.default.createElement(_Page2.default, {
        key: "last",
        pageNumber: T.total_pages,
        onClick: p,
        pageText: u,
        isDisabled: T.current_page === T.total_pages,
        itemClass: (0, _classnames2.default)(g, h),
        linkClass: (0, _classnames2.default)(b, y),
        disabledClass: P
      })), e;
    }
  }, {
    key: "render",
    value: function () {
      var e = this.buildPages();
      return _react2.default.createElement("ul", {
        className: this.props.innerClass
      }, e);
    }
  }]), a;
}();

Pagination.defaultProps = {
  itemsCountPerPage: 10,
  pageRangeDisplayed: 5,
  activePage: 1,
  prevPageText: "⟨",
  firstPageText: "«",
  nextPageText: "⟩",
  lastPageText: "»",
  innerClass: "pagination",
  itemClass: void 0,
  linkClass: void 0,
  activeLinkClass: void 0,
  hideFirstLastPages: !1,
  getPageUrl: function (e) {
    return "#";
  }
}, exports.default = Pagination;